import { render, staticRenderFns } from "./IconBriefcaseOutline.vue?vue&type=template&id=33829aa1"
import script from "./IconBriefcaseOutline.vue?vue&type=script&lang=js"
export * from "./IconBriefcaseOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports